import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'

import Info from './info.js'
import '../css/sidebar.css'

export default class SideBar extends Component {

	handleMouseOver(name){
		if(name !== ''){
			document.getElementsByClassName(name)[0].style.width = '200%';
			document.getElementsByClassName(name)[0].style.opacity = '1';
			document.getElementsByClassName(name)[0].style.visibility = 'visible';
			document.getElementsByClassName(name)[0].style.transition = 'width 0.5s, opacity 1s';
		}
	}
	
	handleMouseLeave(name){
		if(name !== ''){
			document.getElementsByClassName(name)[0].style.width = '0px';
			document.getElementsByClassName(name)[0].style.opacity = '0';
			document.getElementsByClassName(name)[0].style.visibility = 'hidden';
		}
	}
	
	clickMobileIcon(){
		if( window.innerWidth < 768 ){
			document.getElementsByClassName('sidebar')[0].style.display = 'none';
		}
	}
	render() {
	
	return (
	<aside className="sidebar">
		<ul>
			{Object.values(Info).map((link, index) => (
				<li 
					key={index}
					className={`${link.path.replace(/\//g,'')}icon`}
					onMouseOver={() => this.handleMouseOver(link.path.replace(/\//g,''))}
					onMouseLeave={() => this.handleMouseLeave(link.path.replace(/\//g,''))}
				>
				
					<div className={`${link.path.replace(/\//g,'')} link-name`}>
						<div className="name-font">{link.name.toUpperCase()}</div>
					</div>
				
					<NavLink
						to={link.path}
						activeClassName="sidebarIconSelected"
						onClick={this.clickMobileIcon}
					>
						<img
							src={`img/resources/${link.icon}`}
							alt={link.name === 'Home' ? '' : link.name}
						/>
					</NavLink>

				</li>
			))}
		</ul>	
	</aside>
	)}
}


// WEBPACK FOOTER //
// ./src/components/sidebar.js